import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './styles.css';

const NOOP = () => ({});

function ToggleSwitch({ ariaLabel, disabled, id, initialState, onChange, onText, offText, onIcon, offIcon, theme }) {
  const [toggleOn, setToggleOn] = useState(initialState);
  const onIconRef = React.createRef();
  const offIconRef = React.createRef();
  const switchIsNotValid = (onIcon || offIcon) && (onText || offText);
  let divTheme = 'trp-toggle-switch-lt';
  const conditionalKeys = [1, 2, 3, 4];

  const onChangeParent = (e) => {
    const newToggleVal = e.target.checked;
    setToggleOn(newToggleVal);

    if (onChange) {
      onChange(newToggleVal);
    }
  };

  if (theme === 'dark') divTheme = 'trp-toggle-switch-dt';

  if (!switchIsNotValid && onIcon) {
    useEffect(() => {
      onIconRef.current.style.setProperty('background', `url("${onIcon}")`, '');
    });
  }
  if (!switchIsNotValid && offIcon) {
    useEffect(() => {
      offIconRef.current.style.setProperty('background', `url("${offIcon}")`, '');
    });
  }

  return (
    <div className={`${divTheme} beacon-container`}>
      <input
        name="state"
        type="checkbox"
        id={id}
        className="trp-toggle-switch-input"
        onChange={onChangeParent}
        checked={toggleOn}
        disabled={disabled}
        aria-label={ariaLabel}
      />
      <label className={cn('trp-toggle-switch-label', { disabled })} htmlFor={id}>
        <span className={cn('trp-toggle-switch-slider', { disabled })}>
          {!switchIsNotValid &&
            onText && [
              <span className="trp-toggle-switch-slider-text-on trp-toggle-switch-slider-text" key={conditionalKeys[0].toString()}>
                {onText}
              </span>,
            ]}
          {!switchIsNotValid &&
            offText && [
              <span className="trp-toggle-switch-slider-text" key={conditionalKeys[1].toString()}>
                {offText}
              </span>,
            ]}

          {!switchIsNotValid &&
            onIcon && [
              <div
                className="trp-toggle-switch-icon trp-toggle-switch-slider-icon-on trp-toggle-switch-slider-icon"
                ref={onIconRef}
                key={conditionalKeys[2].toString()}
              />,
            ]}
          {!switchIsNotValid &&
            offIcon && [
              <div className="trp-toggle-switch-icon trp-toggle-switch-slider-icon" ref={offIconRef} key={conditionalKeys[3].toString()} />,
            ]}
        </span>
      </label>
      <style jsx>{styles}</style>
    </div>
  );
}

ToggleSwitch.defaultProps = {
  ariaLabel: 'Toggle Switch',
  disabled: false,
  initialState: false,
  onChange: NOOP,
  onText: null,
  offText: null,
  onIcon: null,
  offIcon: null,
  theme: 'light',
};

ToggleSwitch.propTypes = {
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  initialState: PropTypes.bool,
  onChange: PropTypes.func,
  onText: PropTypes.string,
  offText: PropTypes.string,
  onIcon: PropTypes.string,
  offIcon: PropTypes.string,
  theme: PropTypes.string,
};

export default ToggleSwitch;
